var cov_bu2w9a5fu = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/Extra.tsx",
      hash = "d952b566449cf8ccb55d28854b611082c55b1c8b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/Extra.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 19
        },
        end: {
          line: 15,
          column: 6
        }
      },
      "1": {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 14,
          column: 23
        }
      },
      "2": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 61
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        loc: {
          start: {
            line: 9,
            column: 11
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 40
          },
          end: {
            line: 10,
            column: 41
          }
        },
        loc: {
          start: {
            line: 11,
            column: 6
          },
          end: {
            line: 14,
            column: 23
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 9
          },
          end: {
            line: 13,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 13,
            column: 47
          },
          end: {
            line: 13,
            column: 85
          }
        }, {
          start: {
            line: 13,
            column: 88
          },
          end: {
            line: 13,
            column: 92
          }
        }],
        line: 13
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/Extra.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { listClass } from './styles';

var Extra =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Extra, _PureComponent);

  var _super = _createSuper2(Extra);

  function Extra() {
    _classCallCheck(this, Extra);

    return _super.apply(this, arguments);
  }

  _createClass(Extra, [{
    key: "render",
    value: function render() {
      var _this = this;

      cov_bu2w9a5fu.f[0]++;
      var render = (cov_bu2w9a5fu.s[0]++, this.props.extra.map(function (value, index) {
        cov_bu2w9a5fu.f[1]++;
        cov_bu2w9a5fu.s[1]++;
        return (
          /*#__PURE__*/
          React.createElement(React.Fragment, {
            key: index,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 11,
              columnNumber: 7
            }
          }, value, index < _this.props.extra.length - 1 ? (cov_bu2w9a5fu.b[0][0]++,
          /*#__PURE__*/
          React.createElement("div", {
            className: listClass('split'),
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 13,
              columnNumber: 48
            }
          })) : (cov_bu2w9a5fu.b[0][1]++, null))
        );
      }));
      cov_bu2w9a5fu.s[2]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: listClass('extra'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 17,
            columnNumber: 12
          }
        }, render)
      );
    }
  }]);

  return Extra;
}(PureComponent);

export default Extra;